// extracted by mini-css-extract-plugin
export var editInput = "_km-0";
export var editInputCompact = "_km-2";
export var editInputLarge = "_km-1";
export var editInputSmall = "_km-3";